// LoginDropdown.jsx

import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./LoginDropdown.css";

const LoginDropdown = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="market-dropdown-container">
      <button
        className="login-button"
        onClick={() => setOpen(!open)}
      >
        Login
      </button>

      {open && (
        <div className="dropdown-box">
          <div className="dropdown-item">
            <Link style={{textDecoration:"none"}} to='/Patronlogin'> Login as User </Link>
          </div>

          <div className="dropdown-item">
            <Link style={{textDecoration:"none"}} to='/login'> Login as Seller </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginDropdown;